import { Controller } from '@hotwired/stimulus'

// Cycles answer panels: a select or prev/next on the review, a counter on
// present-mode slides.
//
// persistKey is keyed the way the retired response-carousel was, so a teacher's
// position survives both present mode's Turbo re-renders and the upgrade.
export default class extends Controller {
  static targets = ['select', 'answer', 'counter', 'previous', 'next']
  static values = { persistKey: String }

  connect() {
    // A Turbo cache restore keeps the hidden classes, so a reconnect resumes
    // where the teacher was rather than bouncing to the first answer.
    let index = Math.max(0, this.answerTargets.findIndex(panel => !panel.classList.contains('hidden')))
    if (this.hasPersistKeyValue) {
      const savedId = localStorage.getItem(this.persistKeyValue)
      const saved = this.answerTargets.findIndex(panel => panel.dataset.id === savedId)
      if (saved >= 0) index = saved
    }
    this.show(index)
  }

  change() {
    this.show(Number(this.selectTarget.value))
  }

  previous() {
    this.step(-1)
  }

  next() {
    this.step(1)
  }

  step(delta) {
    const count = this.answerTargets.length
    if (count === 0) return

    // Wraps: at an end the button carries disabled, which fires no click.
    this.show((this.index + delta + count) % count)
  }

  show(index) {
    this.index = index
    this.answerTargets.forEach((panel, i) => panel.classList.toggle('hidden', i !== index))
    if (this.hasSelectTarget) this.selectTarget.value = String(index)
    if (this.hasCounterTarget) this.counterTarget.textContent = String(index + 1)
    if (this.hasPreviousTarget) this.toggleDisabled(this.previousTarget, index === 0)
    if (this.hasNextTarget) this.toggleDisabled(this.nextTarget, index === this.answerTargets.length - 1)
    if (this.hasPersistKeyValue) {
      const id = this.answerTargets[index]?.dataset.id
      if (id) localStorage.setItem(this.persistKeyValue, id)
    }
  }

  // disabled stops the click; ui/button paints the look from a literal
  // aria-disabled="true", which is what Tailwind's aria-disabled: matches.
  toggleDisabled(button, disabled) {
    button.toggleAttribute('disabled', disabled)
    if (disabled) button.setAttribute('aria-disabled', 'true')
    else button.removeAttribute('aria-disabled')
  }
}
